// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
.wr-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #ededed;
  font-size: 0.85rem;
  color: #171717;
}
.wr-error {
  padding: 14px 16px;
  border-radius: 12px;
  background: #fef2f2;
  border: 1px solid rgba(220, 38, 38, 0.2);
  color: #dc2626;
  font-size: 0.85rem;
}
.wr-retry-btn {
  display: inline-flex;
  align-items: center;
  padding: 5px 14px;
  border-radius: 999px;
  border: 1px solid #005ff0;
  background: #fff;
  color: #005ff0;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease;
}
.wr-retry-btn:hover:not(:disabled) {
  background: #f0f4ff;
}
.wr-retry-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.wr-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.wr-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0f4ff 0%, #f8f6ff 100%);
  border: 1px solid rgba(0, 95, 240, 0.08);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.wr-hero-left {
  min-width: 0;
}
.wr-kicker {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #005ff0;
  margin-bottom: 2px;
}
.wr-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.2;
}
.wr-status {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #fff;
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.wr-status:hover {
  transform: scale(1.04);
}
.wr-status.wr-status-ready {
  background: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);
}
.wr-status.wr-status-pending {
  background: #ea580c;
  box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.12);
}
.wr-gates {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.wr-gate {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #ededed;
  background: #fff;
  transition: border-color 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.wr-gate:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.wr-gate.wr-gate-pass {
  border-left: 4px solid #16a34a;
}
.wr-gate.wr-gate-fail {
  border-left: 4px solid #dc2626;
  background: #fefafa;
}
.wr-gate-dot {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.78rem;
  line-height: 1;
}
.wr-gate-pass .wr-gate-dot {
  background: rgba(22, 163, 74, 0.12);
  color: #16a34a;
}
.wr-gate-fail .wr-gate-dot {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}
.wr-gate-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #171717;
  line-height: 1.3;
}
.wr-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #ededed;
}
.wr-banner-success {
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-color: rgba(22, 163, 74, 0.2);
}
.wr-banner-warn {
  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%);
  border-color: rgba(234, 88, 12, 0.2);
}
.wr-banner-blocked {
  background: #fafafa;
  border-color: #ededed;
}
.wr-banner-icon {
  font-size: 1.3rem;
  line-height: 1;
  flex-shrink: 0;
}
.wr-banner-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
  margin-bottom: 2px;
}
.wr-banner-sub {
  font-size: 0.8rem;
  color: #a3a3a3;
  line-height: 1.4;
}
.wr-override-err {
  font-size: 0.8rem;
  color: #dc2626;
  margin: 0;
}
.wr-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.wr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;
  padding: 8px 24px;
  border-radius: 12px;
  border: none;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.wr-btn:focus {
  outline: 2px solid rgba(0, 95, 240, 0.3);
  outline-offset: 2px;
}
.wr-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.wr-btn-go {
  flex: 1;
  color: #fff;
  background: #16a34a;
}
.wr-btn-go:hover:not(:disabled) {
  background: #12883e;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(22, 163, 74, 0.2);
}
.wr-btn-override {
  color: #dc2626;
  background: #fff;
  border: 2px solid rgba(220, 38, 38, 0.3);
}
.wr-btn-override:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #dc2626;
  transform: translateY(-1px);
}
.wr-btn-close {
  color: #171717;
  background: #f5f5f5;
  border: 1px solid #ededed;
}
.wr-btn-close:hover:not(:disabled) {
  background: #ededed;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/wizard-readiness-phase.component.less"],"names":[],"mappings":"AAcA;EACE,cAAA;AAbF;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAfF;AAkBA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAjBF;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;AAlBJ;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArBF;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,wCAAA;EACA,yCAAA;AAvBF;AA0BA;EACE,YAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAzBF;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA1BF;AA6BA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,uDAAA;AA3BF;AA6BE;EACE,sBAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,6CAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,6CAAA;AA7BJ;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhCF;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gFAAA;AAjCF;AAmCE;EACE,2BAAA;EACA,yCAAA;AAjCJ;AAoCE;EACE,8BAAA;AAlCJ;AAqCE;EACE,8BAAA;EACA,mBAAA;AAnCJ;AAuCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AArCF;AAuCE;EACE,mCAAA;EACA,cAAA;AArCJ;AAwCE;EACE,kCAAA;EACA,cAAA;AAtCJ;AA0CA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAxCF;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA1CF;AA6CA;EACE,6DAAA;EACA,oCAAA;AA3CF;AA8CA;EACE,6DAAA;EACA,oCAAA;AA5CF;AA+CA;EACE,mBAAA;EACA,qBAAA;AA7CF;AAgDA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AA9CF;AAiDA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA/CF;AAkDA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAhDF;AAmDA;EACE,iBAAA;EACA,cAAA;EACA,SAAA;AAjDF;AAqDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAnDF;AAsDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AApDF;AAsDE;EACE,wCAAA;EACA,mBAAA;AApDJ;AAuDE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AArDJ;AAyDA;EACE,OAAA;EACA,WAAA;EACA,mBAAA;AAvDF;AAyDE;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAvDJ;AA2DA;EACE,cAAA;EACA,gBAAA;EACA,wCAAA;AAzDF;AA2DE;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;AAzDJ;AA6DA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AA3DF;AA6DE;EACE,mBAAA;AA3DJ","sourcesContent":["// UDS-inspired tokens\n@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-orange-70: #ea580c;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host {\n  display: block;\n}\n\n// ── Loading / Error ──\n.wr-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 16px;\n  border-radius: @uds-radius;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n  font-size: 0.85rem;\n  color: @uds-neutral-100;\n}\n\n.wr-error {\n  padding: 14px 16px;\n  border-radius: @uds-radius;\n  background: #fef2f2;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  color: @uds-red-70;\n  font-size: 0.85rem;\n}\n\n.wr-retry-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 14px;\n  border-radius: 999px;\n  border: 1px solid @uds-blue-70;\n  background: #fff;\n  color: @uds-blue-70;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: #f0f4ff;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n// ── Panel ──\n.wr-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n// ── Hero ──\n.wr-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n  border-radius: @uds-radius;\n  background: linear-gradient(135deg, #f0f4ff 0%, #f8f6ff 100%);\n  border: 1px solid rgba(0, 95, 240, 0.08);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.wr-hero-left {\n  min-width: 0;\n}\n\n.wr-kicker {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: @uds-blue-70;\n  margin-bottom: 2px;\n}\n\n.wr-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.2;\n}\n\n.wr-status {\n  flex-shrink: 0;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #fff;\n  transition: transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover {\n    transform: scale(1.04);\n  }\n\n  &.wr-status-ready {\n    background: @uds-green-70;\n    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);\n  }\n\n  &.wr-status-pending {\n    background: @uds-orange-70;\n    box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.12);\n  }\n}\n\n// ── Gates ──\n.wr-gates {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wr-gate {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: @uds-radius;\n  border: 1px solid @uds-neutral-30;\n  background: #fff;\n  transition: border-color @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n  }\n\n  &.wr-gate-pass {\n    border-left: 4px solid @uds-green-70;\n  }\n\n  &.wr-gate-fail {\n    border-left: 4px solid @uds-red-70;\n    background: #fefafa;\n  }\n}\n\n.wr-gate-dot {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 0.78rem;\n  line-height: 1;\n\n  .wr-gate-pass & {\n    background: rgba(22, 163, 74, 0.12);\n    color: @uds-green-70;\n  }\n\n  .wr-gate-fail & {\n    background: rgba(220, 38, 38, 0.1);\n    color: @uds-red-70;\n  }\n}\n\n.wr-gate-text {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n}\n\n// ── Banners ──\n.wr-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: @uds-radius;\n  border: 1px solid @uds-neutral-30;\n}\n\n.wr-banner-success {\n  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);\n  border-color: rgba(22, 163, 74, 0.2);\n}\n\n.wr-banner-warn {\n  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%);\n  border-color: rgba(234, 88, 12, 0.2);\n}\n\n.wr-banner-blocked {\n  background: @uds-neutral-10;\n  border-color: @uds-neutral-30;\n}\n\n.wr-banner-icon {\n  font-size: 1.3rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.wr-banner-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  margin-bottom: 2px;\n}\n\n.wr-banner-sub {\n  font-size: 0.8rem;\n  color: @uds-neutral-50;\n  line-height: 1.4;\n}\n\n.wr-override-err {\n  font-size: 0.8rem;\n  color: @uds-red-70;\n  margin: 0;\n}\n\n// ── Action buttons ──\n.wr-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.wr-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 42px;\n  padding: 8px 24px;\n  border-radius: @uds-radius;\n  border: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:focus {\n    outline: 2px solid rgba(0, 95, 240, 0.3);\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n.wr-btn-go {\n  flex: 1;\n  color: #fff;\n  background: @uds-green-70;\n\n  &:hover:not(:disabled) {\n    background: darken(@uds-green-70, 6%);\n    transform: translateY(-1px);\n    box-shadow: 0 3px 10px rgba(22, 163, 74, 0.2);\n  }\n}\n\n.wr-btn-override {\n  color: @uds-red-70;\n  background: #fff;\n  border: 2px solid rgba(220, 38, 38, 0.3);\n\n  &:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: @uds-red-70;\n    transform: translateY(-1px);\n  }\n}\n\n.wr-btn-close {\n  color: @uds-neutral-100;\n  background: @uds-neutral-20;\n  border: 1px solid @uds-neutral-30;\n\n  &:hover:not(:disabled) {\n    background: @uds-neutral-30;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
